export const removeExtraSpaces = (string?: string) => {
  if (string) return string.replaceAll(/\s/g, '');

  return null;
};
